module.exports = __webpack_public_path__ + "img/estrellas-calificacion.b76d2262.svg";